/**
 * Availability API service
 */

import { apiClient } from './client';
import type {
  Availability,
  SetAvailabilityRequest,
  BulkAvailabilityRequest,
  BulkAvailabilityResponse,
  GetAvailabilityQuery,
  GetAvailabilityResponse,
  GetAvailabilitySummaryQuery,
  GetAvailabilitySummaryResponse,
} from '@/types/api';

/**
 * POST /api/availability
 * Set availability for a user
 */
export async function setAvailability(
  data: SetAvailabilityRequest
): Promise<Availability> {
  const response = await apiClient.post<Availability>('/availability', data);
  return response.data;
}

/**
 * POST /api/availability/bulk
 * Bulk update availability
 */
export async function bulkUpdateAvailability(
  data: BulkAvailabilityRequest
): Promise<BulkAvailabilityResponse> {
  const response = await apiClient.post<BulkAvailabilityResponse>(
    '/availability/bulk',
    data
  );
  return response.data;
}

/**
 * GET /api/availability
 * Get availability with filters
 */
export async function getAvailability(
  params?: GetAvailabilityQuery
): Promise<GetAvailabilityResponse> {
  const response = await apiClient.get<GetAvailabilityResponse>('/availability', {
    params,
  });
  return response.data;
}

/**
 * GET /api/availability/summary
 * Get availability summary for date range (for organizers)
 */
export async function getAvailabilitySummary(
  params: GetAvailabilitySummaryQuery
): Promise<GetAvailabilitySummaryResponse> {
  const response = await apiClient.get<GetAvailabilitySummaryResponse>(
    '/availability/summary',
    { params }
  );
  return response.data;
}

/**
 * DELETE /api/availability/:id
 * Remove availability record
 */
export async function deleteAvailability(id: number): Promise<void> {
  await apiClient.delete(`/availability/${id}`);
}
